export const setAdviceChannelSubCategories = (payload) => ({
  type: 'SET_ADVICE_SUB_CATEGORIES',
  payload,
});

export const setAdviceChannelSelctions = (payload) => ({
  type: 'STORE_USER_SELECTIONS',
  payload,
});